import { Navigate } from 'react-router-dom';
import DashboardLayout from '../../../layouts/dashboard/DashboardLayout';
import maintenanceConfig from '../../../layouts/dashboard/nav/maintenanceConfig';
import Maintenance from '../view/Maintenance';
import { MaintenanceDetail } from '../components';
import AuthGuard from '../../../shared/auth/authGuards';

export const maintenanceRoutes = [
  {
    path: '/maintenance',
    // This subtree was reachable without a token; every other route tree in the
    // app is wrapped in AuthGuard.
    element: (
      <AuthGuard>
        <DashboardLayout navConfig={maintenanceConfig} />
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to="/maintenance/app" />, index: true },
      {
        path: 'app',
        element: <Maintenance />,
      },
      { path: 'app/:id', element: <MaintenanceDetail /> },
    ],
  },
];
